import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PartneriPopisService {

  headers = new Headers();

  constructor(private _http: Http) { 
    this.headers.append('Ocp-Apim-Subscription-Key', '08dfe4bfb67e406f8fa96bd38849411a');
  }

  dohvatiPartnere(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_partnere/', a)    
    .map(res => res.json()); 
  }

  sudskiRegistar(oib:any) {
    return this._http.get('https://sudreg-api.pravosudje.hr/javni/subjekt_detalji?tipIdentifikatora=oib&identifikator='+oib+'&expand_relations=true', {headers: this.headers})
        .map(res => res.json());
  }

  dodajPartnera(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'partner_spremi/', a)    
    .map(res => res.json()); 
  }

  urediPartnera(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'partner_uredi/', a)    
    .map(res => res.json()); 
  }

  partnerDelete(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'partner_delete', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/partneri-popis/partneri-popis.service.ts